module.exports = __webpack_public_path__ + "img/BouOld.027e331b.gif";